import type { PetitionPreviewLinkByIdQuery } from './getPetitionPreviewLinkById/getPetitionPreviewLinkById.graphql';
import type { PreviewLink } from './types';

type ResultPreviewLink = PetitionPreviewLinkByIdQuery['getPetitionPreviewLinkById'];
type ResultPreviewLinkImage = NonNullable<
	PetitionPreviewLinkByIdQuery['petitionBySlugOrId']
>['previewLinksImagesConnection'];

const VARIANT_WITH_IMAGE = 'horizontal_with_image';
const VARIANT_WITHOUT_IMAGE = 'horizontal_without_image';

export function transformPreviewLink(
	resultPreviewLink: ResultPreviewLink,
	resultPreviewLinkImage?: ResultPreviewLinkImage,
): PreviewLink | undefined {
	let previewLinkTitle: string | undefined;

	if (resultPreviewLink.__typename === 'PreviewLink') {
		previewLinkTitle = resultPreviewLink.title;
	}

	/**
	 * TODO: We are assuming that there is only one preview link
	 * with possible two images (with petition images and without
	 * petition image). If the petition does not have image, only
	 * the horizontal_without_image will be returned.
	 *
	 * In the future, we can use the variationName to determine
	 * which image to use per platform and link with the preview
	 * link title.
	 */
	const previewLinkImage = findVariantImage(resultPreviewLinkImage);

	return previewLinkTitle && previewLinkImage
		? {
				title: previewLinkTitle,
				imageUrl: previewLinkImage,
			}
		: undefined;
}

export function findVariantImage(resultPreviewLinkImage?: ResultPreviewLinkImage): string | undefined {
	if (hasNodes(resultPreviewLinkImage)) {
		const variant = resultPreviewLinkImage.nodes.length > 1 ? VARIANT_WITH_IMAGE : VARIANT_WITHOUT_IMAGE;
		return resultPreviewLinkImage.nodes.find((node) => node.variationName === variant)?.url;
	}

	return undefined;
}

function hasNodes(obj: unknown): obj is { nodes: Array<{ url: string; variationName: string }> } {
	return typeof obj === 'object' && obj !== null && 'nodes' in obj && Array.isArray(obj.nodes);
}
